import React from 'react';
import PropTypes from 'prop-types';

import { getSectionIcon } from '../../../helpers/PageSections';

const AdminPageSectionIcon = ({ sectionId }) => {
  const icon = getSectionIcon(sectionId);
  if (!icon) {
    return null;
  }

  return (
    <i className={`section-icon fa-regular ${getSectionIcon(sectionId)}`} />
  );
};

AdminPageSectionIcon.propTypes = {
  sectionId: PropTypes.string.isRequired,
};

export default AdminPageSectionIcon;
